import { ThemedInputProps } from "./props";

/**
 * Applies default props to ThemedInput props
 */
export function withDefaultProps<T = unknown>(props: ThemedInputProps<T>) {
  const {
    id,
    testID,
    inputStyle,
    label,
    style,
    placeholder,
    selectTextOnFocus,
    labelProps,
    labelStyle,
    value = "",
    type = "text",
    onSubmitEditing,
    onChangeText,
    autoComplete,
    secureTextEntry = false,
    keyboardType = "default",
    autoCapitalize = "none",
    editable = true,
    inputPattern,
    required = false,
    items,
    loadItems,
    getItemLabel = (x: any) => String(x),
    keyExtractor = (_, i) => String(i),
    onItemPress,
    renderChoiceItem,
    restrictToList,
    choices,
    validationPattern,
    multiline,
    autoFocus,
  } = props;

  return {
    id,
    testID,
    inputStyle,
    label,
    style,
    placeholder,
    selectTextOnFocus,
    labelProps,
    labelStyle,
    value,
    type,
    onSubmitEditing,
    onChangeText,
    autoComplete,
    secureTextEntry,
    keyboardType,
    autoCapitalize,
    editable,
    inputPattern,
    required,
    items,
    loadItems,
    getItemLabel,
    keyExtractor,
    onItemPress,
    renderChoiceItem,
    restrictToList,
    choices,
    validationPattern,
    multiline,
    autoFocus,
  };
}
